"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DATE_FORMAT_NATIVE = exports.DATE_FORMAT = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _moment = _interopRequireDefault(require("moment"));
var DATE_FORMAT = exports.DATE_FORMAT = 'DD.MM.YYYY';
var DATE_FORMAT_NATIVE = exports.DATE_FORMAT_NATIVE = 'YYYY-MM-DD';
var GermanDateHelpers = /*#__PURE__*/function () {
  function GermanDateHelpers() {
    (0, _classCallCheck2.default)(this, GermanDateHelpers);
  }
  return (0, _createClass2.default)(GermanDateHelpers, null, [{
    key: "dateToGermanString",
    value: function dateToGermanString(dateObject, dateFormatAsYear) {
      var date = dateObject.getDate();
      var month = dateObject.getMonth();
      var dateProps = {
        d: date < 10 ? "0".concat(date) : date,
        m: month + 1 < 10 ? "0".concat(month + 1) : month + 1,
        Y: dateObject.getFullYear()
      };
      if (dateFormatAsYear) {
        return "".concat(dateProps.Y, ".").concat(dateProps.m, ".").concat(dateProps.d);
      }
      return "".concat(dateProps.d, ".").concat(dateProps.m, ".").concat(dateProps.Y);
    }
  }, {
    key: "isValidGermanDateFormat",
    value: function isValidGermanDateFormat(date, props) {
      return !props || !props.isMobile && !props.isTablet ? (0, _moment.default)(date, DATE_FORMAT, true).isValid() : (0, _moment.default)(date, DATE_FORMAT_NATIVE, true).isValid();
    }
  }, {
    key: "germanStringToDate",
    value: function germanStringToDate(dateString, now) {
      if (dateString === '30.11.0002') {
        return new Date('0002-10-30');
      }
      if (!dateString || typeof dateString !== 'string') {
        return null;
      }

      // super trim all
      var val = dateString.replace(/[\s]{1}/g, '');
      val = val.replace(/[\D]/g, '.');
      val = val.replace(/[..]+/g, '.');

      // update dotless format
      if (/^[\d]{6,8}$/.test(val)) {
        val = "".concat(val.substr(0, 2), ".").concat(val.substr(2, 2), ".").concat(val.substr(4));
      }
      var digits = val.split('.');
      if (digits.length === 3) {
        var y = parseInt(digits[2], 10);
        var m = parseInt(digits[1], 10);
        var d = parseInt(digits[0], 10);

        // update short year (useful only for birthdays)
        // TODO: should be updated after the year - 3000 !
        if (now) {
          var shortY = now.getFullYear() - 2000;
          if (y <= shortY) {
            y = 2000 + y;
          } else {
            y = y < 100 ? 1900 + y : y;
          }
        } else if (y < 30) {
          y += 2000;
        } else {
          y = y < 100 ? y + 1900 : y;
        }

        // invalid values
        if (!this.isValidDate(d, m, y)) {
          return null;
        }
        var date = new Date(y, m - 1, d);

        // if valid Date
        if (date && !isNaN(date.getTime())) {
          return date;
        }
      }
      return null;
    }
  }, {
    key: "isValidDate",
    value: function isValidDate(day, month, year) {
      if (isNaN(day) || isNaN(month) || isNaN(year)) {
        return false;
      }
      if (day < 1 || year < 1) {
        return false;
      }
      if (month > 12 || month < 1) {
        return false;
      }
      if ((month === 1 || month === 3 || month === 5 || month === 7 || month === 8 || month === 10 || month === 12) && day > 31) {
        return false;
      }
      if ((month === 4 || month === 6 || month === 9 || month === 11) && day > 30) {
        return false;
      }
      if (month === 2) {
        if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0 && year % 100 === 0) {
          if (day > 29) {
            return false;
          }
        } else if (day > 28) {
          return false;
        }
      }
      return true;
    }
  }]);
}();
var _default = exports.default = GermanDateHelpers;